import {
  NotificationConfig, NotificationType,
} from '@routific/hive';
import { IApp } from '../../store/mst/App';

export const getRearrangeStopFailedMessage = (sequenceNumber: number | null | undefined, routeName?: string | null): string => {
  const stopName = sequenceNumber ? `Stop ${sequenceNumber}` : 'stop';
  return (
    `There was a problem moving ${stopName} in ${routeName}. Please try again.`
  );
};

export const rearrangeStopFailedNotification = (
  store: IApp,
  eventUuid: string | undefined,
  eventId: string | undefined,
  sequenceNumber: number | null | undefined,
  routeName: string | null | undefined,
  error?: string,
): NotificationConfig => ({
  id: `rearrange-stop-${eventUuid || eventId}-failed`,
  type: NotificationType.ERROR,
  message: error || `${getRearrangeStopFailedMessage(sequenceNumber, routeName)}. Please try again in a few minutes.`,
  linkMessage: 'View Stop',
  linkOnClick: () => store.ui.selectRouteEvent(eventId),
  dataCy: 'rearranging-stop-message-failed',
});
